import { categories } from '@/mocks/mangaData';

export default function Categories() {
  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
      <div className="flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-semibold text-secondary-800">
          <i className="ri-book-3-line text-sm" />
          分类书库
        </span>
        <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          万千作品，按你喜欢的方式逛
        </h2>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          恋爱、热血、奇幻、科幻……找到心仪的分类，收藏起来慢慢追。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((c) => (
          <a
            key={c.id}
            href="#trending"
            className="group flex items-center gap-4 rounded-2xl bg-background-50 p-4 ring-1 ring-background-200 transition-colors hover:bg-primary-100/70 hover:ring-primary-300"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-xl`} />
            </span>
            <div className="min-w-0">
              <p className="text-sm font-bold text-foreground-950 md:text-base">{c.name}</p>
              <p className="mt-0.5 truncate text-xs text-foreground-500">
                {c.count} 部 · {c.desc}
              </p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}